module.exports = __webpack_public_path__ + "img/45.24fefab1.png";